import * as RadixToast from '@radix-ui/react-toast';
import { cn } from '../lib/cn.js';

const VARIANT_CLASS = {
  success: 'bg-good text-paper',
  info: 'bg-teal text-paper',
  warning: 'bg-warn text-ink',
  error: 'bg-bad text-paper',
};

const VARIANT_TYPE = {
  success: 'background',
  info: 'background',
  warning: 'foreground',
  error: 'foreground',
};

const VARIANT_ICON = {
  success: '✓',
  info: 'i',
  warning: '⚠',
  error: '×',
};

export const TOAST_DURATION_MS = 5000;

export function Toast({ id, variant = 'info', message, onDismiss }) {
  return (
    <RadixToast.Root
      duration={TOAST_DURATION_MS}
      onOpenChange={(open) => { if (!open) onDismiss(id); }}
      type={VARIANT_TYPE[variant] ?? 'background'}
      className={cn(
        'rounded-card shadow-lg px-4 py-3 pr-10 flex items-start gap-3 relative',
        'data-[state=open]:animate-in data-[state=closed]:animate-out',
        VARIANT_CLASS[variant] ?? VARIANT_CLASS.info,
      )}
    >
      <span aria-hidden className="font-bold text-lg leading-none mt-0.5">
        {VARIANT_ICON[variant] ?? VARIANT_ICON.info}
      </span>
      <RadixToast.Description className="text-sm leading-snug">
        {message}
      </RadixToast.Description>
      <RadixToast.Close
        aria-label="Close"
        className="absolute right-2 top-2 w-6 h-6 rounded-input opacity-80 hover:opacity-100 focus-visible:outline-2"
      >
        ×
      </RadixToast.Close>
    </RadixToast.Root>
  );
}
